import { Card, Input, Switch, Button, message } from 'antd';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import {
	retrieveInternalSettings,
	updateInternalSettings,
} from '../../methods/redux/reducers/internal-settings';
import { getCurrencies } from '../../methods/redux/reducers/currency';
import InvestmentCurrencyItem from '../../core-modules/investment/InvestmentCurrencyItems';

const Style = styled.div`
	& .mini-report {
		& > * {
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
		}
		& .amount {
			font-weight: 600;
			font-size: 16px;

			&.red {
				color: var(--red-color);
			}
		}
	}

	& .out-links {
		display: inline-block;
		margin-right: 20px;
		text-decoration: underline;
	}
`;
const ArrangeCurrencies = styled.div`
	display: flex;
	flex-wrap: no-wrap;
	margin-top: 10px;
`;

const InvestmentSettings = () => {
	const dispatch = useAppDispatch();
	const settings = useAppSelector((store) => store.internalSettings);
	const { currencies } = useAppSelector((store) => store.currencies);

	const [loading, setLoading] = useState(false);
	const [investmentSettings, setInvestmentSettings] = useState({
		_id: '',
		investmentUseBVN: false,
		investmentFatherId: '',
		allowInvestments: false,
		minInvestmentAmountInUSD: 0,
		risevestInterestPercentage: 0,
		risevestEstimatedStockAPY: 0,
		risevestEstimatedRealEstateAPY: 0,
		updateButtonDisabled: true,
	});

	useEffect(() => {
		setInvestmentSettings({
			...investmentSettings,
			...settings,
		});
	}, [settings]);

	const updateInvestmentSettings = async () => {
		try {
			setLoading(true);
			const {
				investmentUseBVN,
				investmentFatherId,
				allowInvestments,
				minInvestmentAmountInUSD,
				risevestInterestPercentage,
				risevestEstimatedStockAPY,
				risevestEstimatedRealEstateAPY,
			} = investmentSettings;

			await dispatch(
				updateInternalSettings({
					settingsId: investmentSettings._id,
					investmentUseBVN,
					investmentFatherId,
					allowInvestments,
					minInvestmentAmountInUSD,
					risevestInterestPercentage,
					risevestEstimatedStockAPY,
					risevestEstimatedRealEstateAPY,
				})
			).unwrap();

			message.success('Investment settings updated successfully!');
			setInvestmentSettings((prev) => ({
				...prev,
				updateButtonDisabled: true,
			}));
		} catch (error: any) {
			console.error(error);

			message.error(
				error ||
					error?.message ||
					'Failed to update investment settings. Please try again.'
			);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		dispatch(retrieveInternalSettings());
		dispatch(getCurrencies({}));
	}, []);

	return (
		<Style>
			<Card>
				<h2>Investment Settings</h2>
				<p>This Page consist of all settings relating to investment process</p>
				<Card>
					<h2>Allow Investment Currencies</h2>
					<p>
						Supported currencies and toggle to enable or disable individual
						currency for Investment.
					</p>
					<ArrangeCurrencies>
						{currencies.map((currency: any) => (
							<InvestmentCurrencyItem key={currency._id} currency={currency} />
						))}
					</ArrangeCurrencies>
				</Card>
				<div className="mini-report" style={{ marginTop: '10px' }}>
					<Link
						title="Settings"
						className="out-links"
						to="/core-modules/investment/unregistered-users"
					>
						<p>View Unregistered Investments</p>
					</Link>
					{/* <Button
						onClick={() =>
							navigate('/core-modules/investment/unregistered-users')
						}
						style={{
							cursor: 'pointer',
						}}
					>
						<p>View Unregistered Investments</p>
					</Button> */}
				</div>

				<p>Manage Rise Vest Process</p>
				<div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
					<Link
						title="Settings"
						className="out-links"
						to="https://dashboard.risevest.co/admin/overview"
					>
						<p>Rise vest Investment</p>
					</Link>
					{/* <Button type="default">
						<a
							href=" https://dashboard.risevest.co/admin/overview"
							target="_blank"
							rel="noopener noreferrer"
						>
							Rise vest Investment
						</a>
					</Button> */}
				</div>
				<br />

				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<p className="label"> Allow Investments</p>
					<Switch
						size="small"
						onChange={(value) =>
							setInvestmentSettings({
								...investmentSettings,
								updateButtonDisabled: false,
								allowInvestments: value,
							})
						}
						checked={investmentSettings.allowInvestments}
					/>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<p className="label">Allow Investment use bvn</p>
					<Switch
						size="small"
						onChange={(value) =>
							setInvestmentSettings({
								...investmentSettings,
								updateButtonDisabled: false,
								investmentUseBVN: value,
							})
						}
						checked={investmentSettings.investmentUseBVN}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
						marginBottom: '15px',
					}}
				>
					<p> Current Investment FatherId Details:</p>{' '}
					<Link
						to={`/user-profile/${investmentSettings.investmentFatherId?._id}`}
					>
						<strong>@{investmentSettings.investmentFatherId?.username}</strong>
					</Link>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<div>
						<p className="label">Investment FatherId </p>
						<Input
							onChange={(e) =>
								setInvestmentSettings({
									...investmentSettings,
									updateButtonDisabled: false,
									investmentFatherId: e.target.value,
								})
							}
						/>
					</div>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<div>
						<p className="label">Minimum Investment Amount In USD</p>
						<Input
							onChange={(e) =>
								setInvestmentSettings({
									...investmentSettings,
									updateButtonDisabled: false,
									minInvestmentAmountInUSD: Number(e.target.value),
								})
							}
							value={investmentSettings.minInvestmentAmountInUSD}
						/>
					</div>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<div>
						<p className="label">Risevest Interest Percentage</p>
						<Input
							onChange={(e) =>
								setInvestmentSettings({
									...investmentSettings,
									updateButtonDisabled: false,
									risevestInterestPercentage: Number(e.target.value),
								})
							}
							value={investmentSettings.risevestInterestPercentage}
						/>
					</div>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<div>
						<p className="label">Risevest Estimated Stock APY</p>
						<Input
							onChange={(e) =>
								setInvestmentSettings({
									...investmentSettings,
									updateButtonDisabled: false,
									risevestEstimatedStockAPY: Number(e.target.value),
								})
							}
							value={investmentSettings.risevestEstimatedStockAPY}
						/>
					</div>
				</div>
				<div className="lined-settings" style={{ marginBottom: '15px' }}>
					<div>
						<p className="label">Risevest Estimated Real Estate APY</p>
						<Input
							onChange={(e) =>
								setInvestmentSettings({
									...investmentSettings,
									updateButtonDisabled: false,
									risevestEstimatedRealEstateAPY: Number(e.target.value),
								})
							}
							value={investmentSettings.risevestEstimatedRealEstateAPY}
						/>
					</div>
				</div>
				<div>
					<Button
						type="default"
						onClick={updateInvestmentSettings}
						disabled={investmentSettings.updateButtonDisabled}
						loading={loading}
					>
						Update
					</Button>
				</div>
			</Card>
		</Style>
	);
};

export default InvestmentSettings;
